<script>
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();

	export let modalMessage;
	export let modalType;

	let color = '';
	let title = '';

	$: {
		if (modalMessage != null) {
			jQuery('#messageDialog').modal('show');
		} else {
			jQuery('#messageDialog').modal('hide');
		}
		if (modalType == 'error') {
			color = 'danger';
			title = 'Error';
		} else if (modalType == 'success') {
			color = 'success';
			title = 'Success';
		} else {
			color = 'primary';
			title = 'Info';
		}
	}

	function closeModal() {
		dispatch('message', {
			action: 'close'
		});
	}
</script>

<div class="modal fade" id="messageDialog" tabindex="-1" role="alert">
	<div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content">
			<div class={'modal-header bg-' + color}>
				<h5 class="modal-title">{title}</h5>
				<button type="button" class="close text-light" on:click={closeModal} data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body text-dark">
				{modalMessage != null ? modalMessage : ''}
			</div>
			<div class="modal-footer">
				<button type="button" class={'btn btn-' + color} on:click={closeModal} data-dismiss="modal">Close</button>
			</div>
		</div>
	</div>
</div>
